/* RESPONSIBLE TEAM: team-self-serve */
import Route from '@ember/routing/route';

export default class IndexRoute extends Route {}
